/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import {
  Card,
  CardBody,
  Table,
  ButtonToolbar,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Button,
  Row,
  Col,
} from 'reactstrap';
import { connect } from 'react-redux';
import moment from 'moment';
import CheckIcon from 'mdi-react/CheckIcon';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import CancelIcon from 'mdi-react/CancelIcon';
import SquareIconButton from '../../../shared/components/custom/SquareIconButton';
import CloseIcon from 'mdi-react/CloseIcon';
import FormCard from '../../../shared/components/custom/FormCard';
import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';
import { toast } from 'react-toastify';
import assignTierValidate from './assignTierValidate';
import renderField from '../../../shared/components/custom/Field';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import t, { partial } from '../../../util/translation/translation';
import renderSelectField from '../../../shared/components/form/Select';
import { isInfiniteDate } from '../../../util/functions';
import Loading from '../../../shared/components/custom/Loading';
import Api from '../../../util/api';

const p = partial('UserTiers');
const s = partial('shared');

const AssignTierForm = ({
  availableTiers,
  currentUserAffiliatons,
  handleSubmit,
  initialize,
  formValues,
  handleModal,
}) => {
  const tierOptions = availableTiers.map((item) => ({
    label: item.name,
    value: item.id,
  }));
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    initialize({
      tier: tierOptions[0],
      dueDate: null,
      neverEnd: null,
      sendPushNotification: false,
    });
  }, [availableTiers, currentUserAffiliatons]);
  const renderUserAffiliations = () => {
    return currentUserAffiliatons.map((affiliation) => {
      const dueDate = isInfiniteDate(affiliation.dueDate)
        ? p('neverEnding')
        : moment(affiliation.dueDate).format('YYYY-MM-DD');
      return (
        <tr key={`Affiliation-${affiliation.id}`}>
          <td className="table-stack__primary">
            <strong className="font-weight-500 text-capitalize">
              {affiliation.tier.name}
            </strong>
          </td>
          <td data-label={s('endDate')}>{dueDate}</td>
          <td data-label={t('MatchTicketsList.assignedBy')}>
            {affiliation.addedByAdmin ? 'Admin' : 'User'}
          </td>
          <td data-label={s('subscriptionActive')}>
            <span
              className={`status-dot ${
                affiliation.subscriptionActive
                  ? 'status-dot--on'
                  : 'status-dot--off'
              }`}
            >
              {affiliation.subscriptionActive ? <CheckIcon /> : <CloseIcon />}
            </span>
          </td>
          <td className="table-stack__actions text-right">
            {/* Admin-given tiers are deleted; a user's own subscription is
                terminated (and can't be once it has ended) */}
            <div className="icon-actions justify-content-end">
              <SquareIconButton
                icon={
                  affiliation.addedByAdmin ? (
                    <DeleteOutlineIcon />
                  ) : (
                    <CancelIcon />
                  )
                }
                title={affiliation.addedByAdmin ? s('delete') : p('terminate')}
                tone="danger"
                id={`remove-affiliation-${affiliation.id}`}
                disabled={
                  !affiliation.addedByAdmin && !affiliation.subscriptionActive
                }
                onClick={() => handleModal(true, affiliation.id)}
              />
            </div>
          </td>
        </tr>
      );
    });
  };
  return (
    <form className="form user-form" onSubmit={handleSubmit}>
      <Loading loading={isLoading} />
      <div className="user-layout user-layout--aside">
        <FormCard title={p('addTier')}>
          <p className="user-form__hint">{p('addTierHint')}</p>
          <div className="form-grid form-grid--stack">
            <div className="form__form-group">
              <span className="form-header">{p('userTier')}</span>
              <Field
                name="tier"
                component={renderSelectField}
                options={tierOptions}
                placeholder={p('selectTier')}
                className="textTransform-capitalize"
              />
            </div>
            <div className="form__form-group">
              <span className="form-header">{s('endDate')}</span>
              <Field
                name="dueDate"
                component={renderField}
                type="date"
                disabled={!!formValues?.neverEnd}
              />
            </div>
            <div className="form__form-group">
              <Field
                name="neverEnd"
                component={renderCheckBoxField}
                className="colored-click"
                label={p('neverEnding')}
              />
            </div>
            <div className="form__form-group">
              <Field
                name="sendPushNotification"
                component={renderCheckBoxField}
                className="colored-click"
                label={s('sendPushNotification')}
              />
            </div>
          </div>
          <div className="messages-form__footer">
            <span />
            <Button color="primary" type="submit" size="sm" className="mb-0">
              {s('save')}
            </Button>
          </div>
        </FormCard>

        {currentUserAffiliatons.length === 0 && (
          <FormCard title={p('currentTiers')}>
            <p className="user-form__empty">{p('noTiers')}</p>
          </FormCard>
        )}
        {currentUserAffiliatons.length > 0 && (
          <FormCard
            title={
              <>
                {p('currentTiers')}
                <span className="form-card__count">
                  {currentUserAffiliatons.length}
                </span>
              </>
            }
            bodyClassName="form-card__body--flush"
          >
            <Table responsive striped className="table--roomy table--stack">
              <thead>
                <tr>
                  <th>{s('name')}</th>
                  <th>{s('endDate')}</th>
                  <th>{t('MatchTicketsList.assignedBy')}</th>
                  <th>{s('subscriptionActive')}</th>
                  <th />
                </tr>
              </thead>
              <tbody>{renderUserAffiliations()}</tbody>
            </Table>
          </FormCard>
        )}
      </div>
    </form>
  );
};

const reduxF = reduxForm({
  form: 'assign_tier_form',
  validate: assignTierValidate,
});

const mapStateToProps = (state) => ({
  formValues: getFormValues('assign_tier_form')(state),
});

export default connect(mapStateToProps)(reduxF(AssignTierForm));
